/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetZReport200ResponseBreakdownTaxRatesValue } from './GetZReport200ResponseBreakdownTaxRatesValue';
import {
    GetZReport200ResponseBreakdownTaxRatesValueFromJSON,
    GetZReport200ResponseBreakdownTaxRatesValueFromJSONTyped,
    GetZReport200ResponseBreakdownTaxRatesValueToJSON,
    GetZReport200ResponseBreakdownTaxRatesValueToJSONTyped,
} from './GetZReport200ResponseBreakdownTaxRatesValue';

/**
 * 
 * @export
 * @interface GetZReport200ResponseBreakdown
 */
export interface GetZReport200ResponseBreakdown {
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdown
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdown
     */
    subtotal: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdown
     */
    tax: number;
    /**
     * 
     * @type {{ [key: string]: GetZReport200ResponseBreakdownTaxRatesValue; }}
     * @memberof GetZReport200ResponseBreakdown
     */
    taxRates: { [key: string]: GetZReport200ResponseBreakdownTaxRatesValue; };
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdown
     */
    discounts: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdown
     */
    taxableBase: number;
    /**
     * 
     * @type {string}
     * @memberof GetZReport200ResponseBreakdown
     */
    taxLabel?: string;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdown
     */
    taxPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseBreakdown
     */
    pending: number;
}

/**
 * Check if a given object implements the GetZReport200ResponseBreakdown interface.
 */
export function instanceOfGetZReport200ResponseBreakdown(value: object): value is GetZReport200ResponseBreakdown {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('subtotal' in value) || value['subtotal'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('taxRates' in value) || value['taxRates'] === undefined) return false;
    if (!('discounts' in value) || value['discounts'] === undefined) return false;
    if (!('taxableBase' in value) || value['taxableBase'] === undefined) return false;
    if (!('pending' in value) || value['pending'] === undefined) return false;
    return true;
}

export function GetZReport200ResponseBreakdownFromJSON(json: any): GetZReport200ResponseBreakdown {
    return GetZReport200ResponseBreakdownFromJSONTyped(json, false);
}

export function GetZReport200ResponseBreakdownFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetZReport200ResponseBreakdown {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'subtotal': json['subtotal'],
        'tax': json['tax'],
        'taxRates': (mapValues(json['taxRates'], GetZReport200ResponseBreakdownTaxRatesValueFromJSON)),
        'discounts': json['discounts'],
        'taxableBase': json['taxableBase'],
        'taxLabel': json['taxLabel'] == null ? undefined : json['taxLabel'],
        'taxPercentage': json['taxPercentage'] == null ? undefined : json['taxPercentage'],
        'pending': json['pending'],
    };
}

export function GetZReport200ResponseBreakdownToJSON(json: any): GetZReport200ResponseBreakdown {
    return GetZReport200ResponseBreakdownToJSONTyped(json, false);
}

export function GetZReport200ResponseBreakdownToJSONTyped(value?: GetZReport200ResponseBreakdown | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'subtotal': value['subtotal'],
        'tax': value['tax'],
        'taxRates': (mapValues(value['taxRates'], GetZReport200ResponseBreakdownTaxRatesValueToJSON)),
        'discounts': value['discounts'],
        'taxableBase': value['taxableBase'],
        'taxLabel': value['taxLabel'],
        'taxPercentage': value['taxPercentage'],
        'pending': value['pending'],
    };
}

